<ng-container>If you take no action, the page will be reset in </ng-container>{{ duration - (interval | async) }}<ng-container> seconds</ng-container>.